module.exports = __webpack_public_path__ + "assets/img/Kitome-Blog-w540.98daec28.jpg";